/**
 * Common schemas used for types that are used on subobjects of various top-level objects.
 */
// const { ContactTypes, WellTypes } = require('../enums');
const {
  requiredString,
  optionalString,
  requiredNumber,
  requiredBool,
  requiredObject,
  optionalObject,
  generatedId,
  optionalNumber,
  arrayOf,
  requiredArrayOf,
  lazy
} = require('../utils');

const {
  mapValues
} = require('lodash/mapValues'); // function documentLinkSchema(objectIsOptional) {
//     return (objectIsOptional ? optionalObject() : requiredObject()).shape({
//         driveFileId: requiredString().max(200),
//         fileName: requiredString().max(1000)
//     });
// }
//
// function quickBooksSyncSchema(objectIsOptional) {
//     return (objectIsOptional ? optionalObject() : requiredObject()).shape({
//         id: requiredString().max(200),
//         syncToken: requiredString().max(200)
//     });
// }


function addressSchema(objectIsOptional) {
  return (objectIsOptional ? optionalObject() : requiredObject()).shape({
    line1: requiredString().max(200),
    line2: optionalString().max(200).nullable(),
    city: requiredString().max(200),
    stateCode: requiredString().length(2),
    zip: requiredString().min(5).max(10)
  });
}

function attributeSchema() {
  return optionalObject().shape({
    required: requiredBool().default(false),
    choice: arrayOf(requiredString()).when('required', {
      is: true,
      then: requiredArrayOf(requiredString(), "Please choose an option"),
      otherwise: arrayOf(requiredString())
    })
  }); // return lazy(obj => {
  //     if (obj.required) {
  //         console.log("required attribute");
  //         return requiredObject().shape({
  //             choice: requiredArrayOf(requiredString()),
  //             name: requiredString()
  //         });
  //     }
  //     return optionalObject().shape({
  //         choice: arrayOf(requiredString()),
  //         name: requiredString()
  //     });
  // });
}

function purchasablePricingOption() {
  return requiredObject().shape({
    credits: requiredNumber(),
    price: requiredNumber(),
    title: requiredString()
  });
}

function businessHoursSchema() {
  return optionalObject().shape({
    mondayOpen: optionalString(),
    mondayClose: optionalString(),
    tuesdayOpen: optionalString(),
    tuesdayClose: optionalString(),
    wednesdayOpen: optionalString(),
    wednesdayClose: optionalString(),
    thursdayOpen: optionalString(),
    thursdayClose: optionalString(),
    fridayOpen: optionalString(),
    fridayClose: optionalString(),
    saturdayOpen: optionalString(),
    saturdayClose: optionalString(),
    sundayOpen: optionalString(),
    sundayClose: optionalString()
  });
}

function sparseLocationsSchema() {
  return arrayOf(sparseLocationSchema());
}

function sparseLocationSchema(required = true) {
  return (required ? requiredObject() : optionalObject()).shape({
    id: requiredString(),
    name: requiredString(),
    address: addressSchema()
  });
} //KBM - HOLY BALLSACKS THIS NEEDS TO BE FIXED ASAP!!!!!!!1


function attributesSchema() {
  return optionalObject().shape({
    "04ec22a4": attributeSchema(),
    "3cafb20d": attributeSchema(),
    "24331fda": attributeSchema(),
    "6c25249b": attributeSchema(),
    "024a0dd9": attributeSchema(),
    "bc5b0e8a": attributeSchema(),
    "d1802d01": attributeSchema(),
    "374f7529": attributeSchema(),
    "2b7ddb01": attributeSchema(),
    "f2755b5b": attributeSchema(),
    "c39240db": attributeSchema(),
    "4ce48f84": attributeSchema(),
    "15404039": attributeSchema(),
    "315b225a": attributeSchema(),
    "34da294c": attributeSchema(),
    "7fcbd86e": attributeSchema(),
    "a06e5893": attributeSchema(),
    "d396e3a8": attributeSchema(),
    "ed8a0853": attributeSchema(),
    "c0bbba41": attributeSchema(),
    "clinicalTrials": attributeSchema()
  });
}

function contactInfoSchema() {
  return requiredObject().shape({
    firstName: requiredString(),
    lastName: requiredString(),
    title: requiredString(),
    email: optionalString()
  });
} // function lineItemSchema(objectIsOptional) {
//     return (objectIsOptional ? optionalObject() : requiredObject()).shape({
//         id: generatedId(),
//         description: requiredString().max(500),
//         quantity: requiredNumber(),
//         amount: requiredNumber(),
//         // quickBooks data should only be needed on invoices, not quotes
//         quickBooks: optionalObject().shape({
//             id: requiredString().max(200),
//             itemTypeId: requiredString().max(200),
//         })
//     });
// }
//
// function historySchema() {
//     return requiredObject().shape({
//         id: generatedId(),
//         action: requiredString().max(200),
//         author: requiredString().max(200),
//         timestamp: requiredDate(),
//         details: optionalString().max(500)
//     })
// }
//
// function contactSchema() {
//     return requiredObject().shape({
//         id: generatedId(),
//         name: requiredString().max(200),
//         role: requiredString().max(200),
//         email: requiredString().email().max(200),
//         phoneNumber: optionalString().max(50),
//         contactType: requiredString().oneOf(ContactTypes.map(contactType => contactType.value))
//     })
// }
//
// function wellSchema() {
//     return requiredObject().shape({
//         id: generatedId(),
//         name: requiredString().max(200),
//         address: addressSchema(false),
//         notes: optionalString().max(5000),
//         wellInfo: optionalObject().shape({
//             description: optionalString().max(500),
//             wellType: optionalString().oneOf(WellTypes.map(wellType => wellType.value)),
//             otherWellTypeDescription: optionalString().max(200),
//             horsePower: optionalNumber(),
//             gallonsPerMinute: optionalNumber(),
//             columnPipeSize: optionalNumber(),
//             pumpSetting: optionalNumber()
//         })
//     })
// }


module.exports = {
  // documentLinkSchema,
  // quickBooksSyncSchema,
  addressSchema,
  attributesSchema,
  attributeSchema,
  businessHoursSchema,
  purchasablePricingOption,
  sparseLocationsSchema,
  sparseLocationSchema,
  contactInfoSchema // lineItemSchema,
  // historySchema,
  // contactSchema,
  // wellSchema

};